import { render, staticRenderFns } from "./vue-vehicle-plate.vue?vue&type=template&id=6992a432&scoped=true"
import script from "./vue-vehicle-plate.vue?vue&type=script&lang=js"
export * from "./vue-vehicle-plate.vue?vue&type=script&lang=js"
import style0 from "./vue-vehicle-plate.vue?vue&type=style&index=0&id=6992a432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6992a432",
  null
  
)

export default component.exports